// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ruleForm {\n  width: 340px;\n  margin: 0 auto;\n}\n.m-upload .ant-upload-select {\n  width: 60px;\n  height: 60px;\n  border: 1px solid #C3C3C3;\n  text-align: center;\n  line-height: 60px;\n}\n.m-upload .ant-upload-select-picture-card i {\n  font-size: 32px;\n  color: #999;\n}\n.m-upload .ant-upload-select-picture-card .ant-upload-text {\n  margin-top: 8px;\n  color: #666;\n}\n", ""]);
// Exports
module.exports = exports;
